import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import classNames from 'classnames';
import type { ComponentProps, ForwardedRef, PropsWithChildren } from 'react';
import { forwardRef } from 'react';

export const blockStyles = cva('', {
  variants: {
    variant: {
      primary: 'rounded-2xl bg-jb-neutral-100 px-3 py-6 lg:p-8',
      outlined:
        'rounded-lg border border-jb-neutral-500 bg-transparent px-2 py-3 lg:p-4',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

type Props = ComponentProps<'div'> & VariantProps<typeof blockStyles>;

const Block = (
  { children, className, variant, ...props }: PropsWithChildren<Props>,
  ref: ForwardedRef<HTMLDivElement>
) => {
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(blockStyles({ variant }), className)}
    >
      {children}
    </div>
  );
};

Block.displayName = 'Block';
export default forwardRef(Block);
